import { render, staticRenderFns } from "./salesInvoiceActive1.vue?vue&type=template&id=c5064dac&scoped=true"
import script from "./salesInvoiceActive1.vue?vue&type=script&lang=js"
export * from "./salesInvoiceActive1.vue?vue&type=script&lang=js"
import style0 from "./salesInvoiceActive1.vue?vue&type=style&index=0&id=c5064dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5064dac",
  null
  
)

export default component.exports